import React, { useState } from "react";
import { BlogHeader } from "../../../components/BlogHeader";
import { BlogDetailContent } from "../../../blocks/blog-detail-content";
import { BlogDetailAside } from "../../../blocks/blog-detail-aside";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";

// import { useTranslation } from "react-i18next";

export const BlogDetailPage = (props) => {
  //   const { t } = useTranslation();
  const [articleDetail, setArticleDetail] = useState(props.articleDetail);

  return (
    <div className="blog-detail-page">
      <BlogHeader />
      <div className="blog-content">
        <BlogDetailContent
          setArticleDetail={setArticleDetail}
          articleDetail={props.articleDetail}
        />
        <BlogDetailAside articleDetail={articleDetail} />
      </div>
      <Footer />
    </div>
  );
};
